import { render, staticRenderFns } from "./consume.vue?vue&type=template&id=5474c5b6&scoped=true"
import script from "./consume.vue?vue&type=script&lang=js"
export * from "./consume.vue?vue&type=script&lang=js"
import style0 from "./consume.vue?vue&type=style&index=0&id=5474c5b6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5474c5b6",
  null
  
)

export default component.exports